import React, { FC } from 'react';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';

import Button, { ButtonProps } from 'vibo-ui/Button';

import useStyles from './style';

const SignInNextButton: FC<ButtonProps> = props => {
  const classes = useStyles();
  const { t } = useTranslation();

  const { errors, isSubmitting } = useFormikContext();

  return (
    <Button
      className={classNames('nextBtn', classes.nextBtn)}
      disabled={!isEmpty(errors) || isSubmitting}
      displayType="primary"
      shape="round"
      size="lg"
      {...props}
    >
      {t('next')}
    </Button>
  );
};

export default SignInNextButton;
